import { Controller } from "@hotwired/stimulus"

// Opens the dialog a `new` action rendered into the modal frame, and empties
// the frame once it closes, so neither a refresh nor going back reopens it.
// RapidRails' own dialog controller only opens from a frame it renders beside
// the <dialog>, not around it (04 › Layout › Modals).
export default class extends Controller {
  connect() {
    this.dialog = this.element.querySelector("dialog")
    this.clear = this.clear.bind(this)
    this.dialog.addEventListener("close", this.clear)
    document.addEventListener("turbo:before-cache", this.clear)
    if (!this.dialog.open) this.dialog.showModal()
  }

  disconnect() {
    this.dialog.removeEventListener("close", this.clear)
    document.removeEventListener("turbo:before-cache", this.clear)
  }

  close() {
    this.dialog.close()
  }

  clear() {
    this.element.closest("turbo-frame")?.removeAttribute("src")
    this.element.remove()
  }
}
